'use strict';
{
    var app = angular.module('tf.portfolio.widgets.whatIfComparison', [])

        .controller('whatIfComparisonCtrl', ['$scope', '$filter', '$localStorage', '$http', '$timeout', '$stateParams', function whatIfComparisonController($scope, $filter, $localStorage, $http, $timeout, $stateParams) {
            $scope.widgetContentHeight = 250;

            $scope.selectedWhatIf = null;

            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });

            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateChartHeight();
            });

            $scope.updateChartHeight = function() {
                $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
            };

            $scope.activeScenario = null;

            $scope.getComparisonResults = function() {
                if ($stateParams.portfolioId) {
                    $http.post('api/portfolio/' + $stateParams.portfolioId + '/whatifs/comparison', $scope.activeScenario)
                        .then(function(response) {
                            $scope.whatIfComparisons = response.data;
                            $scope.whatIfComparisons.forEach(function(whatIf){
                                if (whatIf.name == "Current") {
                                    $scope.currentResult = whatIf;
                                }
                            });
                            $scope.whatIfComparisons.forEach(function(result){
                                if (result.name == "Current" || result.name == "EOD") {
                                    result.whatIf.marginChange = result.whatIf.clientMargin;
                                    result.whatIf.spanChange = result.whatIf.spanMargin;
                                    result.whatIf.premiumChange = result.whatIf.premiumMargin;
                                    result.stressed.marginChange = result.stressed.clientMargin;
                                } else {
                                    result.whatIf.marginChange = result.whatIf.clientMargin -  $scope.currentResult.whatIf.clientMargin;
                                    result.whatIf.spanChange = result.whatIf.spanMargin -  $scope.currentResult.whatIf.spanMargin;
                                    result.whatIf.premiumChange = result.whatIf.premiumMargin -  $scope.currentResult.whatIf.premiumMargin;
                                    result.stressed.marginChange = result.stressed.clientMargin - $scope.currentResult.whatIf.clientMargin;
                                }
                            });
                        })
                } else {
                    $timeout(function () {
                        $scope.getComparisonResults();
                    }, 2000)
                }

            };

            $scope.toggleChanges = function(){
                $scope.changesToggled = !$scope.changesToggled;
            };

            $scope.changesToggled = false;

            $scope.getComparisonResults();

            $scope.$on('stress.scenario.change', function(event, scenario) {
                if (scenario != null) {
                    var activeScenario = {
                        modelType : scenario.modelType || null,
                        marketScenario : scenario.marketScenario,
                        sectorScenarios: scenario.sectorScenarios,
                        securityScenarios: scenario.securityScenarios,
                        asAt : scenario.asAt
                    };
                }
                $scope.activeScenario = activeScenario;
                $scope.getComparisonResults();
            });

            $scope.$on('whatif.flushed', function(event) {
                $scope.getComparisonResults();
            });

            $scope.$on('whatif.changed', function (event, whatIf) {
                if (whatIf) {
                    $scope.selectedWhatIf = whatIf.id;
                } else {
                    $scope.selectedWhatIf = null;
                }
            });
            $scope.selectWhatIf = function(whatIfResult){
                if (whatIfResult.id != null) {
                    $scope.selectedWhatIf = whatIfResult.id;
                    $scope.$emit('whatif.active.change', whatIfResult.id);
                }
            };

            $scope.securityBreakdownSummaryVisible = true;
            $scope.showSecurityBreakdownSummary = function() {
                $scope.securityBreakdownSummaryVisible = true;
            };

            $scope.showSecurityBreakdownDetail = function() {
                $scope.securityBreakdownSummaryVisible = false;
            };
        }]);
}
